import { IRoom, RoomType } from '../index'
import roomImg from '../../../assets/room_types/green/room.png'
import apartamentImg from '../../../assets/room_types/green/apartament.png'
import bedImg from '../../../assets/room_types/green/bed.png'
import boatImg from '../../../assets/room_types/green/boat.png'
import bungalowImg from '../../../assets/room_types/green/bungalow.png'
import camperImg from '../../../assets/room_types/green/camper.png'
import bigHouseImg from '../../../assets/room_types/green/house.png'
import lodgeImg from '../../../assets/room_types/green/maisonette.png'
import houseImg from '../../../assets/room_types/green/smallhouse.png'
import studioImg from '../../../assets/room_types/green/studio.png'
import tentImg from '../../../assets/room_types/green/tent.png'
import villaImg from '../../../assets/room_types/green/villa.png'

export default function(room: IRoom) {
  switch (room.type) {
    case RoomType.Room:
      return roomImg
    case RoomType.Apartament:
      return apartamentImg
    case RoomType.House:
      return houseImg
    case RoomType.Studio:
      return studioImg
    case RoomType.Bungalow:
      return bungalowImg
    case RoomType.Camper:
      return camperImg
    case RoomType.Villa:
      return villaImg
    case RoomType.Tent:
      return tentImg
    case RoomType.Lodge:
      return lodgeImg
    case RoomType.Bed:
      return bedImg
    case RoomType.Boat:
      return boatImg
    case RoomType.BigHouse:
      return bigHouseImg
  }
}
